export const TERMINOS_CONDICIONES_ID = 1;
export const TERMINOS_CONDICIONES_REGLAMENTO_UNID = 4;
export const TERMINOS_CONDICIONES_REGLAMENTO_UERRE = 5;